import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const ConciergeSubmitted = lazy(() => import("@/pages/ConciergeSubmitted"));

export const Route = createFileRoute("/concierge-submitted")({
  component: ConciergeSubmitted,
});
